import { store } from "../state/store.js";
import { el } from "../utils/dom.js";
import { filteredTransponders } from "../core/filter.js";
import { renderTpTable } from "./render/tpTable.js";
import { renderSelectionTable } from "./render/selectionTable.js";
import { renderFavoritesPanel } from "./render/favoritesTable.js";
import { updateFavGroupButtons } from "./widgets/favGroupButtons.js";
import { isMobileLayout, renderMobileViews } from "./mobile.js";

function updateHitCount() {
  const hit = el("hitCount");
  if (hit) hit.textContent = String(filteredTransponders().length);
}

export function updateHeader() {
  const badgeType = el("badgeType");
  const badgeDb = el("badgeDb");
  const badgeTp = el("badgeTp");
  const badgeProg = el("badgeProg");
  const fileName = el("loadedFileName");

  if (badgeType) badgeType.textContent = store.db.sourceType || "–";
  if (badgeDb) badgeDb.textContent = `DB: ${store.db.date || "Datum unbekannt"}`;
  if (badgeTp) badgeTp.textContent = `TP: ${store.transponders.length}`;
  if (badgeProg) badgeProg.textContent = `PRG: ${store.programs.length}`;
  if (fileName) {
    fileName.textContent = store.db.fileName || "–";
    fileName.title = store.db.fileName || "";
  }

  const tabTp = el("tabTpCount");
  if (tabTp) tabTp.textContent = String(store.transponders.length);

  const tabFav = el("tabFavCount");
  if (tabFav) {
    const favCount =
      (Number(el("favFtaTabCount")?.textContent || 0)) +
      (Number(el("favSkyTabCount")?.textContent || 0)) +
      (Number(el("favHdTabCount")?.textContent || 0)) +
      (Number(el("favK20TabCount")?.textContent || 0)) +
      (Number(el("favOwnTabCount")?.textContent || 0));
    tabFav.textContent = String(favCount);
  }

  const selSize = store.selection?.size || 0;

  const tabSel = el("tabSelCount");
  if (tabSel) tabSel.textContent = String(selSize);

  const selCountBtn = el("selCountBtn");
  if (selCountBtn) selCountBtn.textContent = String(selSize);

  const selCountBtn2 = el("selCountBtn2");
  if (selCountBtn2) selCountBtn2.textContent = String(selSize);

  const selCount = el("selCount");
  if (selCount) selCount.textContent = String(selSize);

  const selCountHeader = el("selCountHeader");
  if (selCountHeader) selCountHeader.textContent = String(selSize);

  const selReadyHint = el("selReadyHint");
  if (selReadyHint) {
    selReadyHint.textContent =
      selSize > 0
        ? "für Export und Weiterverarbeitung bereit"
        : "Noch keine Auswahl";
  }

  const clearSelBtn = el("clearSelBtn");
  if (clearSelBtn) clearSelBtn.disabled = selSize === 0;
}

export function updateUI() {
  updateHeader();
  updateHitCount();
  if (isMobileLayout()) {
    renderMobileViews();
  } else {
    renderTpTable();
    renderSelectionTable();
    renderFavoritesPanel();
  }
  updateFavGroupButtons();
  updateHeader();
}
